import { defineMessages } from 'react-intl';

export const messages: {
	showInSidebar: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	showInSidebar: {
		id: 'navigation.global-side-navigation.more-menu.show-in-sidebar.label',
		description:
			'Label on Show in sidebar button in the side navigation. Button appears in place of the More menu when items are being dragged.',
		defaultMessage: 'Show in sidebar',
	},
});
